import { styled } from 'styled-components';

import { textStyles } from '#/theme/theme';

export const StyledText = styled.div<{
  $styleAs?: keyof typeof textStyles;
  $lineClamp?: number;
}>`
  ${(props) => props.$styleAs && textStyles[props.$styleAs]}

  ${(props) =>
    props.$lineClamp &&
    `
      /* stylelint-disable-next-line value-no-vendor-prefix */
      display: -webkit-box;
      /* stylelint-disable-next-line property-no-vendor-prefix */
      -webkit-line-clamp: ${props.$lineClamp};
      /* stylelint-disable-next-line property-no-vendor-prefix */
      -webkit-box-orient: vertical;
      overflow: hidden;
    `}
`;
